import { render, staticRenderFns } from "./UiSimplePreloader.vue?vue&type=template&id=7fd4aa70&"
import script from "./UiSimplePreloader.vue?vue&type=script&lang=js&"
export * from "./UiSimplePreloader.vue?vue&type=script&lang=js&"
import style0 from "./UiSimplePreloader.vue?vue&type=style&index=0&id=7fd4aa70&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports